import type {ArchiveRecord} from 'archive/ArchiveConstants';
import type {Permissions} from 'auth/PermissionConstants';

export const ARCHIVE_EVENT_PAYLOADS = {
  BULK_ARCHIVE_ASSAY_SCHEMAS_COMPLETED: {} as {
    itemIds: Array<string>;
    archiveRecordsByItemId: {[itemId: string]: ArchiveRecord};
  },
  BULK_ARCHIVE_BATCHES_COMPLETED: {} as {
    itemIds: Array<string>;
  },
  BULK_ARCHIVE_CONNECTIONS: {} as {
    itemIds: Array<string>;
  },
  BULK_ARCHIVE_FILES_COMPLETED: {} as {
    itemIds: Array<string>;
    permissionsByItemId: {[itemId: string]: Permissions};
    archiveRecordsByItemId: {[itemId: string]: ArchiveRecord};
  },
  BULK_ARCHIVE_ANALYSES_COMPLETED: {} as {
    itemIds: Array<string>;
  },
  BULK_ARCHIVE_PROCESS_MANAGEMENT: {} as {
    itemIds: Array<string>;
    archiveRecordsByItemId: {[itemId: string]: ArchiveRecord};
  },
  BULK_ARCHIVE_SOURCES_COMPLETED: {} as {
    itemIds: Array<string>;
    permissionsByItemId: {[itemId: string]: Permissions};
    archiveRecordsByItemId: {[itemId: string]: ArchiveRecord};
  },
  BULK_ARCHIVE_REGISTRIES_COMPLETED: {} as {
    itemIds: Array<string>;
    registryId: string;
  },
  BULK_ARCHIVE_STORABLES_COMPLETED: {} as {
    itemIds: Array<string>;
  },
  BULK_ARCHIVE_TAG_SCHEMAS_COMPLETED: {} as {
    itemIds: Array<string>;
  },
  BULK_ARCHIVE_TEMPLATE_COLLECTIONS_COMPLETED: {} as {
    itemIds: Array<string>;
  },
  BULK_ARCHIVE_STORABLE_SCHEMAS_COMPLETED: {} as {
    itemIds: Array<string>;
    archiveRecordsByItemId: {[itemId: string]: ArchiveRecord};
  },
  BULK_ARCHIVE_SCHEMA_FIELD_SELECTORS_COMPLETED: {} as {
    itemIds: Array<string>;
    archiveRecordsByItemId: {[itemId: string]: ArchiveRecord};
  },
  BULK_UNARCHIVE_ASSAY_SCHEMAS_COMPLETED: {} as {
    itemIds: Array<string>;
  },
  BULK_UNARCHIVE_BATCHES_COMPLETED: {} as {
    itemIds: Array<string>;
  },
  BULK_UNARCHIVE_CONNECTIONS: {} as {
    itemIds: Array<string>;
  },
  BULK_UNARCHIVE_FILES_COMPLETED: {} as {
    itemIds: Array<string>;
    permissionsByItemId: {[itemId: string]: Permissions};
  },
  BULK_UNARCHIVE_ANALYSES_COMPLETED: {} as {
    itemIds: Array<string>;
  },
  BULK_UNARCHIVE_PROCESS_MANAGEMENT: {} as {
    itemIds: Array<string>;
  },
  BULK_UNARCHIVE_SOURCES_COMPLETED: {} as {
    itemIds: Array<string>;
    permissionsByItemId: {[itemId: string]: Permissions};
  },
  BULK_UNARCHIVE_STORABLES_COMPLETED: {} as {
    itemIds: Array<string>;
  },
  BULK_UNARCHIVE_TAG_SCHEMAS_COMPLETED: {} as {
    itemIds: Array<string>;
  },
  BULK_UNARCHIVE_TEMPLATE_COLLECTIONS_COMPLETED: {} as {
    itemIds: Array<string>;
  },
  BULK_UNARCHIVE_STORABLE_SCHEMAS_COMPLETED: {} as {
    itemIds: Array<string>;
  },
  BULK_UNARCHIVE_SCHEMA_FIELD_SELECTORS_COMPLETED: {} as {
    itemIds: Array<string>;
  },
} as const;

export type ArchiveEventPayload = typeof ARCHIVE_EVENT_PAYLOADS;
